import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getApi, postApi } from './utils/utils';

export const useActivateAutoMining = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ days, pairId }) =>
      postApi('/user/auto-mining/activate', { days, pairId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auto-mining', 'status'] });
      queryClient.invalidateQueries({ queryKey: ['home-corausel'] });
      queryClient.invalidateQueries({ queryKey: ['top-pair'] });
    },
  });
};

export const useGetAutoMiningStatus = (pairId) => {
  return useQuery({
    queryKey: ['auto-mining', 'status', pairId],
    queryFn: () => getApi(`/user/auto-mining/status/${pairId}`),
    staleTime: 0,
    enabled: Boolean(pairId),
  });
};
